var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("section", { attrs: { id: "order_bunner" } }, [
                  _c("img", {
                    staticClass: "bunner_gif",
                    attrs: { src: _vm.sketchBunnerGif }
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "sketch_upload_btn" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage("top/sketch/sketchorder_start.png")
                        },
                        on: { click: _vm.goUpload }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [
                    _vm._v("どこよりも早く、どこよりも低価格でご提供できる理由")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sketch_margin_img" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.getImage("top/sketch/sketchorder_img01.png")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: _vm.getImage("top/sketch/sketchorder_img02.png")
                    }
                  })
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("darosとは")]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: _vm.getImage("top/sketch/daros.gif") }
                  })
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [
                    _vm._v("どこよりも早く、どこよりも低価格でご提供できる理由")
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "sketch_sub_head" }, [
                    _c("h3", [_vm._v("ご注文について")]),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage("top/sketch/sketchorder_img03.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "sketch_img_center" }, [
                        _vm._v("スケッチオーダーのご注文フロー")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "sketch_upload_btn" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.getImage(
                              "top/sketch/sketchorder_start.png"
                            )
                          },
                          on: { click: _vm.goUpload }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                !_vm.isHaseko
                  ? _c("div", [
                      _c("a", { attrs: { href: "tel:0362761123" } }, [
                        _c("img", {
                          attrs: { src: _vm.getImage("bunner/TEL.webp") }
                        })
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            ラフなスケッチでも、ミリスタイルの担当が不明点をお電話などでご確認させていただきますのでご安⼼ください。"
      ),
      _c("br"),
      _vm._v(
        "\n            ミリスタイル専⽤のダロス⾃動⽣成クラウドを利⽤して、ミリスタイルスタッフがスケッチを参考に再プランニングすることで、"
      ),
      _c("br"),
      _vm._v(
        "\n            図⾯や⾒積書は全て⾃動的に⽣成しご提案させて頂きます。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            設計・製造データを⾃動⽣成する専用クラウドシステムdaros(ダロス）を活用することで、製品の設計から製造までの人的工数を大幅に削減しております。"
      ),
      _c("br"),
      _vm._v(
        "\n            その結果、一般的なオーダー家具と比較し、圧倒的な低価格・短納期で、製品の提供をしております。また、darosには充分な実績をもつオーダー家具の設計ルールがデジタルプログラム化されており、安心安全設計の製品を提供しております。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sketch_sub_head" }, [
      _c("h3", [_vm._v("色柄 / 素材について")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n              あらかじめ登録している素材の中からご要望にマッチするものを選択してご提供させて頂きます。"
        ),
        _c("br"),
        _vm._v(
          "\n              （住宅業界に大量に供給されている量的背景を持った素材をメインに採用しておりますので、オーダー家具でありながら量産品と同じ材料費でご提供が可能となりました。)\n            "
        )
      ]),
      _vm._v(" "),
      _c("div", [_c("div", [_c("img")]), _vm._v(" "), _c("div", [_c("img")])]),
      _vm._v(" "),
      _c("div", { staticClass: "detail_btn5 btn_pos_center" }, [
        _vm._v("色柄/素材見本帳請求")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sketch_sub_head" }, [
      _c("h3", [_vm._v("扇形状など、加工方法について")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n              あらかじめ登録しているユニット類(扉や箱形状)の中からご要望にマッチするものを選択してご提案させて頂きます。"
        ),
        _c("br"),
        _vm._v(
          "\n              （住宅業界に大量に供給されている量産品に使用される各種ユニット形状と加工方法を採用しておりますので、オーダー家具でありながら量産品と同様の加工費でのご提供が可能となりました。さらに、加工安定性と安心安全設計を併せ持つ、量産可能なオーダー家具のご提供が可能となりました。)\n            "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img"),
        _vm._v(" "),
        _c("div", [
          _c("div", [_vm._v("ユニット名:開き扉")]),
          _vm._v(" "),
          _c("div", [_vm._v("素材:")]),
          _vm._v(" "),
          _c("div", [_vm._v("形状:")]),
          _vm._v(" "),
          _c("div", [_vm._v("板厚:")]),
          _vm._v(" "),
          _c("div", [_vm._v("カラー:")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n              スケッチを頂戴してご提案内容が決まりましたら、お客様の買い物かごにご提案内容を保存させて頂きます。"
      ),
      _c("br"),
      _vm._v(
        "\n              内容をご確認いただき、そのままmm/styleで購入いただけます。\n            "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be4db854", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be4db854","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcSketchOrder.vue
// module id = null
// module chunks = 